import { render, staticRenderFns } from "./CartPayments.vue?vue&type=template&id=cfc53e28"
import script from "./CartPayments.vue?vue&type=script&lang=js"
export * from "./CartPayments.vue?vue&type=script&lang=js"
import style0 from "./CartPayments.vue?vue&type=style&index=0&id=cfc53e28&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports